import { Outlet } from 'react-router-dom'
import {
  Box,
  Flex,
  Heading,
  Spacer,
  Button,
  Container,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  Text,
  HStack,
} from '@chakra-ui/react'
import { FiChevronDown, FiLogOut, FiUser } from 'react-icons/fi'
import { useAuth } from '../hooks/useAuth'
import Navigation from './Navigation'
import NotificationCenter from './NotificationCenter'

export default function Layout() {
  const { user, logout } = useAuth()

  const handleLogout = () => {
    logout()
  }

  return (
    <Box minH="100vh">
      {/* Header */}
      <Box bg="brand.600" color="white" px={4} py={3}>
        <Container maxW="container.xl">
          <Flex align="center">
            <Heading size="md">SGS流程管理系統</Heading>
            <Spacer />

            <HStack spacing={4}>
              <NotificationCenter />

              <Menu>
                <MenuButton as={Button} variant="ghost" color="white" rightIcon={<FiChevronDown />}>
                  <HStack spacing={2}>
                    <Avatar size="sm" name={user?.name} />
                    <Box textAlign="left">
                      <Text fontSize="sm" fontWeight="medium">
                        {user?.name}
                      </Text>
                      <Text fontSize="xs" opacity={0.8}>
                        {user?.role === 'admin' && '系統管理員'}
                        {user?.role === 'business' && '業務人員'}
                        {user?.role === 'sampler' && '採樣人員'}
                        {user?.role === 'lab_staff' && '實驗室人員'}
                        {user?.role === 'finance' && '財務人員'}
                      </Text>
                    </Box>
                  </HStack>
                </MenuButton>
                <MenuList color="black">
                  <MenuItem icon={<FiUser />}>
                    個人資料
                  </MenuItem>
                  <MenuItem icon={<FiLogOut />} onClick={handleLogout}>
                    登出
                  </MenuItem>
                </MenuList>
              </Menu>
            </HStack>
          </Flex>
        </Container>
      </Box>

      <Flex>
        {/* Sidebar Navigation */}
        <Navigation />

        {/* Main Content */}
        <Box flex="1" p={6}>
          <Container maxW="container.xl">
            <Outlet />
          </Container>
        </Box>
      </Flex>
    </Box>
  )
}